import { Text } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import { connect } from 'react-redux';
import { resolve } from '../../../utils/object/pathResolver';

const StaticDOB = ({ fields, defaultValue }) => {
  return (
    <div className="vds-form__group vds-form__group--limited-width">
      <Text
        tag="label"
        htmlFor={fields.name?.value}
        className="vds-form__label show"
        field={fields.label}
      />
      <p className="vds-content-block__secondary-title">{defaultValue}</p>
    </div>
  );
};
const formatDate = dateStr => {
  if (!dateStr) {
    return '';
  }
  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${day}/${month}/${year}`;
};
const mapStateToProps = (state, props) => {
  const reduxValuePath = props.fields.reduxValuePath?.value;
  let defaultValue;
  if (reduxValuePath) {
    const rawValue = resolve(reduxValuePath, state);
    defaultValue = formatDate(rawValue);
  }
  return {
    ...props,
    defaultValue,
  };
};
export default connect(mapStateToProps)(StaticDOB);
